import React, { Component } from "react";
import { View, StyleSheet, TouchableHighlight, ScrollView } from "react-native";
import Text from "../../components_v2/TextFont";
// import { TouchableHighlight } from "react-native-gesture-handler";
import ArTheme from "../../argon-ui/Theme";

import { translate } from "../../locales/translate";
import { IconButton } from "../../components_v2/Buttons";
import { getIconPicture } from "./Icons";
import { englishToPersianNumber, getIsRTL } from "../../util";
import {
  faCalendar,
  faClock,
  faLongArrowAltDown,
  faLongArrowAltUp,
  FONT_FAMILIES,
} from "../../../assets/consts/faCharCodes";
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
class TransactionListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOnPress = () => {
    if (this.props.onPress) {
      this.props.onPress();
    }
  };
  render() {
    return (
      <View
        // key={i}
        style={{
          flex: 1,
          flexDirection: "row",
          borderBottomWidth: 1,
          borderColor: ArTheme.COLORS.MUTED,
          padding: 3,
          alignItems: "center",
          flex: 1,
          justifyContent: "center",
          backgroundColor:
            this.props.orderData.numTransAmount > 0
              ? "#f2fff0"
              : this.props.orderData.numTransAmount < 0
              ? "#fff7f7"
              : "#FFF",
          // height: 58,
        }}
      >
        <IconButton
          onPress={this.handleOnPress}
          style={{
            width: 50,
            height: 50,
            borderRadius: 25,
            borderWidth: 1,
            borderColor: ArTheme.COLORS.MUTED,
            paddingTop: 5,
          }}
          icon={{
            code: getIconPicture(
              "facilityIcons",
              this.props.orderData.numServiceType
            ),
            style: {
              fontFamily: FONT_FAMILIES.PRO_REGULAR,
              fontSize: 27,
              color: "#006666",
            },
          }}
        />
        <View
          style={{
            flexGrow: 1,
            flex: 1,
            paddingStart: 7,
            paddingEnd: 5,
            justifyContent: "center",
          }}
        >
          <TouchableHighlight
            underlayColor="#ddd"
            onPress={() => {
              this.handleOnPress();
            }}
          >
            <View>
              <ScrollView style={{ flexGrow: 1 }}>
                <View
                  style={{
                    flexDirection: "row",
                    textAlignVertical: "top",
                    justifyContent: "space-between",
                    flex: 1,
                    marginTop: 10,
                  }}
                >
                  <View>
                    <Text
                      style={{
                        //paddingTop: 5,
                        fontFamily: "IRANSansWebFaNum",
                        fontSize: 18,
                        fontWeight: "bold",
                        minWidth: 110,
                      }}
                    >
                      {this.props.orderData.numRequestID}
                      {"-"}
                      {/* {translate(`api.orderTypes.${this.props.orderData.numServiceType}`) } */}
                      {this.props.orderData.strServiceTypeName}
                    </Text>
                    {/* dateTime */}
                    <View
                      style={{
                        flexDirection: getIsRTL() ? "row-reverse" : "row",
                        justifyContent: getIsRTL() ? "flex-end" : "flex-start",
                        alignItems: "center",
                      }}
                    >
                      {/* <View style={styles.iconView}>  </View> */}
                      <FontAwesomeIcon
                        icon={faCalendar}
                        color="gray"
                        size={14}
                        style={styles.iconView}
                      />

                      <Text
                        style={[
                          styles.numbers,
                          styles.dateTime,
                          { marginLeft: 15 },
                        ]}
                      >
                        {englishToPersianNumber(
                          this.props.orderData.dtRegisterPDate
                        )}
                      </Text>

                      <FontAwesomeIcon
                        icon={faClock}
                        color="gray"
                        size={14}
                        style={styles.iconView}
                      />
                      <Text style={[styles.numbers, styles.dateTime]}>
                        {englishToPersianNumber(
                          this.props.orderData.dtRegisterTime
                        )}
                      </Text>
                    </View>
                  </View>

                  {this.props.orderData.numTransAmount > 0 && (
                    <View style={{ flexDirection: "row" }}>
                      <Text style={{ paddingStart: 4 }}>
                        {translate("increaseCredit.deposit")}
                      </Text>
                      {/* <View style={styles.iconView}>  </View> */}
                      <FontAwesomeIcon
                        icon={faLongArrowAltDown}
                        color="green"
                        size={20}
                      />
                    </View>
                  )}
                  {this.props.orderData.numTransAmount <= 0 && (
                    <View style={{ flexDirection: "row" }}>
                      <Text style={{ paddingStart: 0, paddingTop: 7 }}>
                        {translate("increaseCredit.withdraw")}
                      </Text>
                      <FontAwesomeIcon
                        icon={faLongArrowAltUp}
                        color="red"
                        size={20}
                      />
                    </View>
                  )}
                </View>
              </ScrollView>
              <View
                style={{
                  flexDirection: "row",
                  textAlignVertical: "top",
                  justifyContent: "space-between",
                  marginTop: 15,
                }}
              >
                <View style={{ flexDirection: "row" }}>
                  <Text style={{ fontSize: 16 }}>
                    {translate("increaseCredit.amount")}
                    {": "}
                  </Text>
                  <Text
                    style={{
                      writingDirection: "ltr",
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    {englishToPersianNumber(
                      this.props.orderData.numTransAmount,
                      ","
                    )}{" "}
                  </Text>
                  <Text style={{ fontSize: 16 }}>
                    {translate("api.priceUnit")}
                  </Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <Text>
                    {translate("increaseCredit.credit")}
                    {": "}
                  </Text>
                  <Text>
                    {englishToPersianNumber(
                      this.props.orderData.numAfterBalance,
                      ","
                    )}{" "}
                  </Text>
                  <Text>{translate("api.priceUnit")}</Text>
                </View>
              </View>
            </View>
          </TouchableHighlight>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  numbers: {
    fontFamily: "IRANSansWebFaNum",
    fontSize: 15,
  },
  dateTime: { fontSize: 12 },
  mainText: {
    fontSize: 18,
  },
  descText: {
    fontSize: 14,
    color: "gray",
  },
  iconView: { marginStart: 5 },
});

export default TransactionListItem;
